const geocode = async (location) => {
  const encodedLocation = encodeURIComponent(location);
  const response = await fetch(`https://geocoding-api.open-meteo.com/v1/search?name=${encodedLocation}&count=1&language=en&format=json`);
  if (!response.ok) {
    throw new Error('Failed to geocode location');
  }
  const data = await response.json();
  if (!data.results || data.results.length === 0) {
    throw new Error('Location not found');
  }
  return {
    latitude: data.results[0].latitude,
    longitude: data.results[0].longitude,
  };
};

export default geocode;
